import {
  ALL_PLACEMENTS,
  FACEBOOK_AND_INSTAGRAM,
  FACEBOOK_AND_INSTAGRAM_FEEDS,
  FACEBOOK_FEEDS,
  FACEBOOK_ONLY,
  INSTAGRAM_FEEDS,
  INSTAGRAM_ONLY,
  RECOMMENDED_PLACEMENTS,
  STORIES_AND_REELS
} from './fields'
import {
  FACEBOOK_BIZ_DISCO_FEED,
  FACEBOOK_FACEBOOK_REELS,
  FACEBOOK_FACEBOOK_REELS_OVERLAY,
  FACEBOOK_FEED,
  FACEBOOK_INSTANT_ARTICLE,
  FACEBOOK_INSTREAM_VIDEO,
  FACEBOOK_MARKETPLACE,
  FACEBOOK_RIGHT_HAND_COLUMN,
  FACEBOOK_SEARCH,
  FACEBOOK_STORY,
  FACEBOOK_VIDEO_FEEDS,
  INSTAGRAM_EXPLORE,
  INSTAGRAM_EXPLORE_HOME,
  INSTAGRAM_IG_SEARCH,
  INSTAGRAM_PROFILE_FEED,
  INSTAGRAM_REELS,
  INSTAGRAM_STORY,
  INSTAGRAM_STREAM,
  lineItemRecommendedPlacementsList,
  MESSENGER_STORY
} from '../../../placements/fields'
import {
  DESTINATION_TYPE,
  ENGAGEMENT_TYPE,
  POST_ENGAGEMENT,
  THRUPLAY,
  TWO_SECOND_CONTINUOUS_VIDEO_VIEWS
} from '../../../LineItemForms/LineItemFacebookCreate/LineItemFacebookCreateForm/fields'
import { PAGE_LIKES } from '../../../../../constants/reusableObjectives'
import { FB_PAGE_CHOICE } from '../../../AdForms/fields'

export const formatPlacementsOptionsToBE = values => {
  const { placements_option } = values

  switch (placements_option) {
    case ALL_PLACEMENTS:
      // if ALL_PLACEMENTS is selected, don't send any placements in the payload
      return []
    case RECOMMENDED_PLACEMENTS:
      return lineItemRecommendedPlacementsList.map(({ value }) => value)
    case FACEBOOK_AND_INSTAGRAM:
      // all valid placements starting with facebook or instagram
      return [
        FACEBOOK_FEED,
        INSTAGRAM_STREAM,
        FACEBOOK_MARKETPLACE,
        FACEBOOK_VIDEO_FEEDS,
        FACEBOOK_RIGHT_HAND_COLUMN,
        INSTAGRAM_EXPLORE,
        FACEBOOK_STORY,
        INSTAGRAM_STORY,
        INSTAGRAM_REELS,
        FACEBOOK_INSTREAM_VIDEO,
        FACEBOOK_SEARCH,
        FACEBOOK_INSTANT_ARTICLE,
        FACEBOOK_BIZ_DISCO_FEED,
        FACEBOOK_FACEBOOK_REELS,
        FACEBOOK_FACEBOOK_REELS_OVERLAY,
        INSTAGRAM_IG_SEARCH,
        INSTAGRAM_PROFILE_FEED,
        INSTAGRAM_EXPLORE_HOME
        // todo SHOP-1744 This one need to be added on BE
        // INSTAGRAM_REELS_OVERLAY
      ]
    case FACEBOOK_ONLY:
      // all valid placements starting with facebook
      return [
        FACEBOOK_FEED,
        FACEBOOK_MARKETPLACE,
        FACEBOOK_VIDEO_FEEDS,
        FACEBOOK_RIGHT_HAND_COLUMN,
        FACEBOOK_STORY,
        FACEBOOK_INSTREAM_VIDEO,
        FACEBOOK_SEARCH,
        FACEBOOK_INSTANT_ARTICLE,
        FACEBOOK_BIZ_DISCO_FEED,
        FACEBOOK_FACEBOOK_REELS,
        FACEBOOK_FACEBOOK_REELS_OVERLAY
      ]
    case INSTAGRAM_ONLY:
      // all valid placements starting with instagram
      return [
        INSTAGRAM_STREAM,
        INSTAGRAM_EXPLORE,
        INSTAGRAM_STORY,
        INSTAGRAM_REELS,
        INSTAGRAM_IG_SEARCH,
        INSTAGRAM_PROFILE_FEED,
        INSTAGRAM_EXPLORE_HOME
        // todo SHOP-1744 This one need to be added on BE
        // INSTAGRAM_REELS_OVERLAY
      ]
    case FACEBOOK_AND_INSTAGRAM_FEEDS:
      // facebook feed, instagram feed, instagram profile feed
      return [FACEBOOK_FEED, INSTAGRAM_STREAM, INSTAGRAM_PROFILE_FEED]
    case FACEBOOK_FEEDS:
      // facebook feed
      return [FACEBOOK_FEED]
    case INSTAGRAM_FEEDS:
      // instagram feed, instagram profile feed
      return [INSTAGRAM_STREAM, INSTAGRAM_PROFILE_FEED]
    case STORIES_AND_REELS:
    default:
      // all stories and reels placements
      return [FACEBOOK_STORY, INSTAGRAM_STORY, MESSENGER_STORY, INSTAGRAM_REELS]
  }
}

export const getPayloadForEngagementObjective = ({ values, reusablePayload }) => {
  const engagementType = values[ENGAGEMENT_TYPE]
  switch (engagementType) {
    case THRUPLAY:
      return {
        ...reusablePayload,
        objective: THRUPLAY,
        [DESTINATION_TYPE]: 'on_video'
      }
    case TWO_SECOND_CONTINUOUS_VIDEO_VIEWS:
      return {
        ...reusablePayload,
        objective: TWO_SECOND_CONTINUOUS_VIDEO_VIEWS,
        [DESTINATION_TYPE]: 'on_video'
      }
    case PAGE_LIKES:
      return {
        ...reusablePayload,
        objective: PAGE_LIKES,
        [DESTINATION_TYPE]: 'on_page',
        promoted_object: {
          page_id: values[FB_PAGE_CHOICE]
        }
      }
    case POST_ENGAGEMENT:
    default:
      return {
        ...reusablePayload,
        objective: POST_ENGAGEMENT,
        [DESTINATION_TYPE]: 'on_post'
      }
  }
}
